import React, { useState, useEffect } from 'react'
import DateFormat from '../../shared/helpers/date-format'

const OrderItemsDisplay = ({ orderItems, handleOnClickExchange }) => {
  document.body.scrollTop = document.documentElement.scrollTop = 0
  let { slashed, time } = DateFormat

  return (
    <>
      {orderItems.map(product => (
        <div
          key={product.perfNo}
          data-testid={product.perfNo}
        >
          <p
            key={product.eventDetails.title}
            className="pb-0 mb-0 mt-40"
          >
            <strong>{product.eventDetails.title}</strong>
            <br />
            {slashed(product.performanceDateTime)}

            {product.eventDetails.hasZones
              ? [', ', product.zoneDisplayName]
              : null}

            {product.eventDetails.isTimed
              ? [', ', time(product.performanceDateTime)]
              : null}
          </p>

          {product.performance_details.ticketInfo.map((ticketInfo, i) => (
            <span key={ticketInfo.priceTypeId}>
              {ticketInfo.priceTypeLabel !== null
                ? ticketInfo.ticketQnty
                : `Quantity: ${ticketInfo.ticketQnty}`}{' '}
              {ticketInfo.priceTypeLabel}
              {i < product.performance_details.ticketInfo.length - 1
                ? ', '
                : ' '}
            </span>
          ))}
          {product.isExchangeable && !product.isCancellable && (
            <div>
              <button
                data-testid={`btnExchange_${product.perfNo}`}
                onClick={e =>
                  handleOnClickExchange(
                    e,
                    product.eventDetails.nativeEventId,
                    product.perfNo,
                    false
                  )
                }
                className="button -dark -medium mt-16"
              >
                Exchange
              </button>
            </div>
          )}

          {product.isExchangeable && product.isCancellable && (
            <div>
              <button
                className="text-depths  underline text-18"
                onClick={e =>
                  handleOnClickExchange(
                    e,
                    product.eventDetails.nativeEventId,
                    product.perfNo,
                    true
                  )
                }
              >
                I do not plan to use these tickets. Please cancel them.
              </button>
            </div>
          )}
        </div>
      ))}
    </>
  )
}

export default OrderItemsDisplay
